import { Layout } from "antd";
import { CodeForm } from "features/auth";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";
import { AuthHeader } from "widgets/headers";

export const CodePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { phone, token } = location.state || {};

  useEffect(() => {
    if (!phone || !token) {
      navigate(ROUTES.LOGIN);
    }
  }, [phone, token, navigate]);

  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "13vh",
        }}
        className="auth-layout-content"
      >
        <CodeForm phone={phone} token={token} />
      </Layout.Content>
    </Layout>
  );
};
